import { table } from './_table';

export const sip_trunks = {
  namespaced: true,
  modules: {
    table
  }
};
